import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { detectDevice } from '../utils/detectDevice';

import config from '@/config';

async function sendDeviceVisit(slug: string) {
  const payload = await detectDevice(slug);

  const response = await fetch(
    `${config.apiUrl.replace(/\/$/, '')}/device-tracker/visits/browser`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }
  );

  if (!response.ok) {
    throw new Error(`Device tracker responded with ${response.status}`);
  }
}

export const DeviceCheckRedirect = () => {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!slug) return;

    const redirectTo = searchParams.get('to') || config.deviceRedirectUrl;
    let cancelled = false;

    const redirect = () => {
      if (!cancelled) {
        window.location.replace(redirectTo);
      }
    };

    sendDeviceVisit(slug)
      .catch((error) => {
        console.error('Device check failed:', error);
      })
      .finally(redirect);

    const hardTimeout = window.setTimeout(redirect, 4000);

    return () => {
      cancelled = true;
      window.clearTimeout(hardTimeout);
    };
  }, [searchParams, slug]);

  return null;
};
